/*
 * Buy 1 wallet, get 2 free: the shopper fills three slots from two open grids, Wallets then Mini Wallets, each with
 * the deepest stock first; every design is on screen, nothing behind a filter or a Show more. The priciest pick is paid, the other two are free; the feratia-discount "pay-priciest" campaign
 * (pack 3:1) does the same maths at checkout for every line carrying the page's offer key.
 * With data-tiers on the root (the tier page) the shopper also picks a deal: buy 1 get 2 / buy 2 get 4 / buy 3 get 6,
 * each with an optional extra amount off a full set; the campaign's packs carry the same `off`.
 * Forked from shared.js (the wallet + free bag page) so the live page's script is never touched.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-fw]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  // Weekly deadline: "this Sunday" in US Eastern time, so every shopper sees the same date (text only).
  (function () {
    var els = $$('[data-fw-ends]');
    if (!els.length || !window.Intl) return;
    var now = {};
    try {
      new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric'})
        .formatToParts(new Date()).forEach(function (p) { now[p.type] = p.value; });
    } catch (e) { return; }
    var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(now.weekday);
    if (dow < 0) return;
    var ahead = (7 - dow) % 7;
    var sunday = new Date(Date.UTC(Number(now.year), Number(now.month) - 1, Number(now.day) + ahead));
    var date = sunday.toLocaleDateString('en-US', {timeZone: 'UTC', month: 'short', day: 'numeric'});
    var today = ahead === 0;
    var text = {
      hero: today ? 'Offer ends today, Sunday, ' + date : 'Offer ends this Sunday, ' + date,
      note: today ? 'Offer ends tonight (Sunday, ' + date + '), or sooner if the shelf is clear.'
                  : 'Offer ends Sunday, ' + date + ', or sooner if the shelf is clear.'
    };
    els.forEach(function (el) { var t = text[el.getAttribute('data-fw-ends')]; if (t) el.textContent = t; });
  })();

  var data;
  try { data = JSON.parse($('[data-fw-pool]').textContent || '{}'); } catch (e) { data = {}; }
  // Wallets first, then Mini Wallets; inside each kind the design with the most units in stock leads.
  var kindRank = {wallet: 0, mini: 1};
  var items = (data.items || []).filter(function (p) { return p && p.id && p.img; })
    .sort(function (a, b) {
      return ((kindRank[a.kind] || 0) - (kindRank[b.kind] || 0)) || ((b.stock || 0) - (a.stock || 0)) ||
        String(a.design).localeCompare(String(b.design));
    });
  if (!items.length) {
    var pickBox = $('.a__pick');
    if (pickBox) pickBox.innerHTML = '<div class="fw__over"><p class="fw__over-t">The clearance shelf is empty.</p>' +
      '<p>Thank you for being part of it. Our wallets are still here at their normal price.</p>' +
      '<a class="fw__atc" href="/collections/all">See all Feratia designs</a></div>';
    var stk = $('[data-fw-sticky]'); if (stk) stk.remove();
    return;
  }

  var SET = 3, PAID = 1, OFF = 0, CAP = Infinity, LOW = 10;
  // Offer tiers (tier page only): [{n, paid, off, cap?, title}]; tier 0 is the page's own set (3, pay for 1).
  var TIERS = [];
  try { TIERS = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { TIERS = []; }
  TIERS = (Array.isArray(TIERS) ? TIERS : []).filter(function (t) { return t && t.n > 0 && t.paid > 0 && t.paid <= t.n; });
  var TIER = 0;
  var OFFER_KEY = root.getAttribute('data-offer-key') || 'wallet-b1g2';
  var IS_PROTOTYPE = !window.Shopify || root.hasAttribute('data-fw-prototype');
  var money = function (n) { return '$' + n.toFixed(2); };
  var moneyShort = function (n) { return n % 1 === 0 ? '$' + n : money(n); }; // $10 rather than $10.00
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  };
  var sized = function (url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var isMini = function (p) { return p.kind === 'mini'; };
  var shot = function (p, w, lazy) {
    return '<span class="fw__shot' + (isMini(p) ? ' fw__shot--mini' : '') + '"><img src="' + esc(sized(p.img, w)) +
      '" alt="" width="600" height="800"' + (lazy ? ' loading="lazy"' : '') + ' decoding="async"></span>';
  };
  var kindName = function (p) { return isMini(p) ? 'Mini Wallet' : 'Wallet'; };
  var label = function (p) { return p.n + (isMini(p) ? ' Mini Wallet' : ' wallet'); };
  // Prices of the priciest designs first: a full set of a tier costs at most its `paid` top prices, less its extra off.
  var TOP = items.map(function (p) { return p.price; }).sort(function (a, b) { return b - a; });
  var tierPrice = function (t) {
    var top = Math.min(t.cap || Infinity, TOP.slice(0, t.paid).reduce(function (s, x) { return s + x; }, 0));
    return Math.max(0, top - (t.off || 0));
  };
  var SIZE = {wallet: 'Zip-around · wrist strap · 4.3″ × 7.9″', mini: 'Zip top · cards, cash, coins · 4.5″ × 3.2″'};

  var wideMq = window.matchMedia('(min-width:760px)');

  var st = {picks: [], busy: false, msg: '', warn: false};

  // The page's own texts are the tier-0 texts; other tiers get theirs from the set size.
  var tier0 = {};
  ['step', 'step-p', 'hint', 'rhead', 'tip'].forEach(function (k) { var el = $('[data-b3-' + k + ']'); tier0[k] = el ? el.textContent : ''; });
  function applyTier(i) {
    var t = TIERS[i]; if (!t) return;
    TIER = i; SET = t.n; PAID = t.paid; OFF = t.off > 0 ? t.off : 0; CAP = t.cap || Infinity;
    // Going down a tier keeps the shopper's most recent picks (the same rule as a swap).
    if (st.picks.length > SET) st.picks = st.picks.slice(st.picks.length - SET);
  }
  applyTier(0);

  var countOf = function (p) { return st.picks.filter(function (x) { return x === p; }).length; };
  // Receipt order = checkout order: priciest first (that one is paid); ties keep the order they were picked.
  var ordered = function () {
    return st.picks.map(function (p, i) { return {p: p, i: i}; })
      .sort(function (a, b) { return b.p.price - a.p.price || a.i - b.i; })
      .map(function (x) { return x.p; });
  };
  var ofKind = function (kind) { return items.filter(function (p) { return p.kind === kind; }); };
  // What the set costs: the PAID priciest picks (capped); the tier's extra off comes off once the set is full,
  // the same as the discount (it belongs to a full pack).
  var priceOf = function (picks) {
    var paid = Math.min(CAP, picks.slice(0, PAID).reduce(function (s, p) { return s + p.price; }, 0));
    return Math.max(0, paid - (picks.length >= SET ? OFF : 0));
  };

  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  function card(p) {
    var i = items.indexOf(p);
    return '<div class="fw__vcard" data-b3-i="' + i + '" data-on="false">' +
      '<button type="button" class="fw__vcard-pick" data-pick-only aria-label="Add ' + esc(label(p)) + '">' +
      shot(p, window.innerWidth >= 760 ? 300 : 480, true) +
      '<span class="b3__cnt" aria-hidden="true" hidden></span>' +
      (p.stock && p.stock <= LOW ? '<span class="b3__low">Only ' + p.stock + ' left</span>' : '') +
      '<span class="fw__vcard-n">' + esc(p.n) + '</span>' +
      '<span class="fw__vcard-p"><span class="b3__kind">' + kindName(p) + '</span>' + money(p.price) + '</span></button>' +
      '<button type="button" class="fw__vcard-detl" data-lens aria-label="See inside: ' + esc(label(p)) + '">See inside ›</button></div>';
  }

  // The grids are drawn once: with every design on screen, a redraw on each tap would reload 26 photos on an old phone.
  function drawGrids() {
    $$('[data-b3-group]').forEach(function (box) {
      var kind = box.getAttribute('data-b3-group'), list = ofKind(kind);
      box.hidden = !list.length;
      if (!list.length) return;
      box.querySelector('[data-b3-grid]').innerHTML = list.map(card).join('');
      box.querySelector('[data-b3-count]').textContent =
        list.length + (list.length > 1 ? ' designs' : ' design') + ' · ' + money(list[0].price) + ' each';
    });
    var all = [[ofKind('wallet').length, 'Wallet'], [ofKind('mini').length, 'Mini Wallet']]
      .filter(function (k) { return k[0]; })
      .map(function (k) { return k[0] + ' ' + k[1] + (k[0] > 1 ? 's' : ''); }).join(' and ');
    setText('[data-b3-all-n]', 'All ' + all);
  }
  function markCards() {
    $$('[data-b3-i]').forEach(function (el) {
      var n = countOf(items[Number(el.getAttribute('data-b3-i'))]);
      el.setAttribute('data-on', String(n > 0));
      var b = el.querySelector('.b3__cnt');
      b.hidden = !n;
      b.textContent = n > 1 ? '×' + n : '✓';
    });
  }

  function render() {
    markCards();

    var tiersBox = $('[data-b3-tiers]');
    if (tiersBox && TIERS.length > 1) {
      tiersBox.hidden = false;
      // One row per deal: radio, title, "6 wallets" + extra-savings pill (deeper yellow on the top tier), price.
      tiersBox.innerHTML = TIERS.map(function (t, i) {
        var on = i === TIER;
        return '<button type="button" class="b3__tr' + (on ? ' is-on' : '') + '" data-b3-tier="' + i + '" aria-pressed="' + on + '">' +
          '<span class="b3__tr-dot" aria-hidden="true"></span><span class="b3__tr-mid"><span class="b3__tr-t">' + esc(t.title) + '</span>' +
          '<span class="b3__tr-s">' + t.n + ' wallets' +
          (t.off > 0 ? '<span class="b3__tr-tag' + (i === TIERS.length - 1 ? ' b3__tr-tag--hot' : '') + '">Extra ' + moneyShort(t.off) + ' off</span>' : '') +
          '</span></span><span class="b3__tr-p">' + money(tierPrice(t)) + '</span></button>';
      }).join('');
      var base = TIER === 0;
      setText('[data-b3-step]', base ? tier0.step : 'Choose your ' + SET + ' wallets');
      setText('[data-b3-step-p]', base ? tier0['step-p'] : 'Pay for ' + PAID);
      setText('[data-b3-hint]', base ? tier0.hint : 'Tap a design to add it. ' + (SET - PAID) + ' of your ' + SET + ' are free.');
      setText('[data-b3-rhead]', base ? tier0.rhead : SET + ' wallets · pay for ' + PAID);
      setText('[data-b3-tip]', base ? tier0.tip : 'Pick any ' + SET + '. You pay for the ' + PAID + ' highest-priced ones.');
    }

    var picks = ordered(), n = picks.length;
    var slots = $('[data-b3-slots]');
    if (slots) {
      // Sets of 6 or 9: thumbnail-only slots; 6 sit on one row, 9 on one row from 760px and 5 + 4 on a phone.
      slots.classList.toggle('b3__slots--compact', SET > 3);
      slots.style.gridTemplateColumns = 'repeat(' + (SET <= 6 || wideMq.matches ? SET : 5) + ',1fr)';
      var out = '', flashed = false;
      for (var k = 0; k < SET; k += 1) {
        var p = picks[k];
        var fresh = p && p === st.justAdded && !flashed;
        if (fresh) flashed = true;
        out += p
          ? '<div class="b3__slot is-on' + (fresh ? ' is-new' : '') + '">' + shot(p, 240) +
            '<button type="button" class="b3__slot-x" data-b3-x="' + items.indexOf(p) + '" aria-label="Remove ' + esc(label(p)) + '">×</button>' +
            '<span class="b3__slot-n">' + esc(p.n) + (isMini(p) ? ' Mini' : '') + '</span>' +
            (k < PAID ? '<span class="b3__slot-p">' + money(p.price) + '</span>'
                      : '<span class="b3__slot-p free"><s>' + money(p.price) + '</s>FREE</span>') + '</div>'
          : '<div class="b3__slot"><span class="b3__slot-e"><span><b>+</b>' + (k < PAID ? 'Wallet ' + (k + 1) : 'Free wallet ' + (k - PAID + 1)) + '</span></span></div>';
      }
      slots.innerHTML = out;
      st.justAdded = null;
    }
    var full = $('[data-b3-full]');
    if (full) {
      full.textContent = st.msg || (n === SET ? 'All ' + SET + ' picked. Tap another design to swap out your first pick.' : n ? 'Pick ' + (SET - n) + ' more.' : '');
      full.classList.toggle('is-warn', st.warn);
    }

    var rows = $('[data-b3-rows]');
    if (rows) {
      var html = '';
      if (SET > 3) {
        // Paid picks one per row, the free picks grouped in one row, then the extra-savings row.
        var freePicks = picks.slice(PAID), freeWorth = freePicks.reduce(function (s, x) { return s + x.price; }, 0);
        for (var r2 = 0; r2 < PAID; r2 += 1) {
          var q2 = picks[r2];
          html += q2
            ? '<div class="a__row">' + shot(q2, 300) + '<span class="what">' + esc(label(q2)) + '<small>' + SIZE[q2.kind] + '</small></span>' +
              '<span class="amt">' + money(q2.price) + '</span></div>'
            : '<div class="a__row a__row--empty"><span class="b3__ph"></span><span class="what">' +
              (r2 ? 'Wallet ' + (r2 + 1) : 'Your first wallet') + '<small>Tap a design above</small></span><span class="amt"></span></div>';
        }
        html += '<div class="a__row a__row--free"><span class="b3__ph b3__ph--free">' + (SET - PAID) + '</span><span class="what">' +
          (SET - PAID) + ' free wallets (' + freePicks.length + ' of ' + (SET - PAID) + ' picked)</span>' +
          '<span class="amt">' + (freeWorth ? '<s>' + money(freeWorth) + '</s>' : '') + '<span class="free">FREE</span></span></div>';
      } else {
        for (var r = 0; r < SET; r += 1) {
          var q = picks[r];
          html += q
            ? '<div class="a__row">' + shot(q, 300) +
              '<span class="what">' + esc(label(q)) + '<small>' + SIZE[q.kind] + '</small>' + (r >= PAID ? '<span class="a__gift">Free</span>' : '') + '</span>' +
              '<span class="amt">' + (r >= PAID ? '<s>' + money(q.price) + '</s><span class="free">FREE</span>' : money(q.price)) + '</span></div>'
            : '<div class="a__row a__row--empty"><span class="b3__ph"></span><span class="what">' +
              (r >= PAID ? 'Free wallet ' + (r - PAID + 1) : 'Your first wallet') + '<small>Tap a design above</small></span><span class="amt"></span></div>';
        }
      }
      if (OFF) html += '<div class="a__row a__row--bonus"><span class="b3__ph b3__ph--bonus">+</span><span class="what">Extra savings for ' + SET +
        '<small>' + (n >= SET ? 'Applied to your set' : 'When all ' + SET + ' are picked') + '</small></span>' +
        '<span class="amt">' + (n >= SET ? '−' + moneyShort(OFF) : '') + '</span></div>';
      rows.innerHTML = html;
    }
    var worth = picks.reduce(function (s, p) { return s + p.price; }, 0);
    var pay = priceOf(picks);
    setText('[data-b3-worth]', money(worth));
    setText('[data-b3-save]', money(worth - pay));
    setText('[data-b3-pay]', money(pay));
    var tot = $('.a__total'); if (tot) tot.hidden = !n;
    var tip = $('[data-b3-tip]'); if (tip) tip.hidden = !!n;

    var ready = n === SET;
    var ctaText = st.busy ? 'Adding your set…' : ready ? 'Add to cart' : 'Pick ' + (SET - n) + ' more wallet' + (SET - n > 1 ? 's' : '');
    setText('[data-b3-cta-label]', ctaText);
    setText('[data-b3-sticky-label]', ready || st.busy ? ctaText : n ? 'Pick ' + (SET - n) + ' more' : 'Choose ' + SET + ' wallets');
    $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.setAttribute('aria-disabled', String(!ready || st.busy)); });
    setText('[data-b3-sticky-p]', ready ? 'You pay ' + money(pay) : SET + ' for ' + money(tierPrice({paid: PAID, cap: CAP, off: OFF})));
    setText('[data-fw-sticky-sub]', n ? picks.map(function (p) { return p.n; }).join(' · ') : 'Pick any ' + SET + '. Pay for ' + PAID + '.');
  }

  function announce(msg) { var l = $('[data-fw-live]'); if (l) l.textContent = msg; }
  function say(msg, warn) { st.msg = msg; st.warn = !!warn; }

  // The set is always the shopper's most recent taps: with the set full, a new tap drops the oldest pick, so a
  // mis-tap never forces a hunt for the × first. Tapping a design already in the set means "one more of these", so
  // the oldest pick of a DIFFERENT design goes (never "Swapped X for X").
  function add(p) {
    var full = st.picks.length >= SET;
    var dropAt = -1;
    if (full) {
      for (var j = 0; j < st.picks.length; j += 1) { if (st.picks[j] !== p) { dropAt = j; break; } }
      if (dropAt < 0) { say('All ' + SET + ' are ' + label(p) + ' already.', false); render(); return; }
    }
    var out = dropAt > -1 ? st.picks[dropAt] : null;
    if (p.stock && countOf(p) + 1 > p.stock) { say('Only ' + p.stock + ' left in ' + label(p) + '.', true); render(); return; }
    if (out) st.picks.splice(dropAt, 1);
    st.picks.push(p);
    st.justAdded = p;
    var left = SET - st.picks.length;
    if (out) {
      say('Swapped ' + label(out) + ' for ' + label(p) + '.', false); render();
      announce('Swapped ' + label(out) + ' for ' + label(p) + '. Your ' + SET + ' are picked.');
      return;
    }
    say('', false); render();
    announce(label(p) + ' added. ' + (left ? left + ' more to pick.' : 'Your ' + SET + ' are picked.'));
    if (!left) { var c = $('[data-fw-cta]'); if (c) setTimeout(function () { c.scrollIntoView({behavior: 'smooth', block: 'center'}); }, 150); }
  }
  function removeOne(p) {
    var at = st.picks.lastIndexOf(p);
    if (at > -1) st.picks.splice(at, 1);
    say('', false); render();
    announce(label(p) + ' removed.');
  }

  root.addEventListener('click', function (e) {
    var tb = e.target.closest('[data-b3-tier]');
    if (tb) {
      if (st.busy) return;
      applyTier(Number(tb.getAttribute('data-b3-tier'))); say('', false); render();
      announce('Choose your ' + SET + ' wallets. Pay for ' + PAID + '.');
      return;
    }
    var x = e.target.closest('[data-b3-x]');
    if (x) { removeOne(items[Number(x.getAttribute('data-b3-x'))]); return; }
    var c = e.target.closest('[data-b3-i]');
    if (!c) return;
    var item = items[Number(c.getAttribute('data-b3-i'))];
    if (e.target.closest('[data-lens]')) openSheet(item);
    else if (e.target.closest('[data-pick-only]')) add(item);
  });

  function addToCart() {
    if (st.busy) return;
    if (st.picks.length < SET) {
      say('Pick ' + (SET - st.picks.length) + ' more to finish your set.', true); render();
      var s = $('[data-b3-slots]'); if (s) s.scrollIntoView({behavior: 'smooth', block: 'center'});
      return;
    }
    st.busy = true; setError(''); render();
    var props = {_feratia_offer: OFFER_KEY};
    try { var src = new URL(window.location.href).searchParams.get('utm_source'); if (src) props._feratia_src = src; } catch (e) {}
    // One tap = one set of 3; the same design picked twice goes in as one line with quantity 2.
    var qty = {};
    st.picks.forEach(function (p) { qty[p.id] = (qty[p.id] || 0) + 1; });
    var lines = Object.keys(qty).map(function (id) { return {id: Number(id), quantity: qty[id], properties: props}; });
    var done = function () {
      st.busy = false; st.picks = [];
      say('Your set is in the cart. Want more? Pick ' + SET + ' more.', false); render();
    };
    if (IS_PROTOTYPE) {
      setTimeout(function () { window.alert('Prototype: this would add to cart\n\n' + JSON.stringify(lines, null, 1)); done(); }, 300);
      return;
    }
    post('/cart/add.js', {items: lines}).then(function () {
      if (document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]')) {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles: true}));
        setTimeout(done, 1200);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      st.busy = false; render();
      setError(err && err.status === 422 && err.message
        ? err.message + ' Please choose another design.'
        : 'Something went wrong. Please try again, or write to cs@feratia.com.');
      var el = $('[data-fw-err]'); if (el) el.scrollIntoView({block: 'center'});
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.ok) return j;
        throw {status: r.status, message: j.description || j.message || ''};
      });
    });
  }
  function setError(msg) { var el = $('[data-fw-err]'); if (el) el.textContent = msg; }

  // Opening this page unlocks the deal for the whole cart: the discount reads the `_feratia_unlock` cart
  // attribute (comma list of offer keys), so wallets the shopper adds later from any page still count.
  function unlockOffer() {
    if (IS_PROTOTYPE) return;
    fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (c) {
      var cur = (c.attributes && c.attributes._feratia_unlock) || '';
      var keys = cur.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
      if (keys.indexOf(OFFER_KEY) !== -1) return;
      keys.push(OFFER_KEY);
      return post('/cart/update.js', {attributes: {_feratia_unlock: keys.join(',')}});
    }).catch(function () {});
  }
  unlockOffer();

  $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.addEventListener('click', addToCart); });
  // The 9-slot layout changes at 760px.
  if (wideMq.addEventListener) wideMq.addEventListener('change', render); else if (wideMq.addListener) wideMq.addListener(render);

  // Sticky bar: shown once the shopper has scrolled past the top and no Add to cart is on screen.
  var sticky = $('[data-fw-sticky]');
  var ctas = $$('[data-fw-cta]');
  if (sticky && 'IntersectionObserver' in window && ctas.length) {
    sticky.inert = true;
    var seen = new Map(), stickyWas = false;
    // The store's popup app draws its teaser inside an open shadow root, bottom-centre over the bar.
    var liftPopupTeaser = function (on, h) {
      Array.prototype.forEach.call(document.body.children, function (el) {
        var sr = el.shadowRoot;
        if (!sr || !sr.querySelector('.hcp-layer, .hcp-teaser-wrap')) return;
        var tag = sr.querySelector('style[data-fw-lift]');
        if (!on) { if (tag) tag.remove(); return; }
        if (!tag) { tag = document.createElement('style'); tag.setAttribute('data-fw-lift', ''); sr.appendChild(tag); }
        tag.textContent = '.hcp-teaser-wrap{margin-bottom:' + (h + 8) + 'px}';
      });
    };
    var syncSticky = function () {
      var anyVisible = false;
      ctas.forEach(function (c) { var v = seen.get(c); if (v && v.visible) anyVisible = true; });
      var on = !anyVisible && window.scrollY > 500;
      sticky.classList.toggle('is-on', on); sticky.inert = !on; sticky.setAttribute('aria-hidden', String(!on));
      if (on !== stickyWas) {
        stickyWas = on;
        document.documentElement.classList.toggle('fw-sticky-on', on);
        document.documentElement.style.setProperty('--fw-sticky-h', sticky.offsetHeight + 'px');
        liftPopupTeaser(on, sticky.offsetHeight);
      }
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, {visible: en.isIntersecting}); });
      syncSticky();
    });
    ctas.forEach(function (c) { io.observe(c); });
    window.addEventListener('scroll', syncSticky, {passive: true});
  }

  // ---------------------------------------------------------------- detail sheet
  var sheet = document.createElement('dialog');
  sheet.className = 'fw__sheet';
  sheet.setAttribute('aria-label', 'Details');
  root.appendChild(sheet);
  function openSheet(p) {
    // The pool's last photo is the open wallet (checked on all 26 products): it goes right after the front shot,
    // and the sheet opens on it, since "See inside" is the only way in.
    var photos = (p.imgs || []).slice(0, 7);
    if (photos.length) photos.unshift(photos.pop());
    var n = photos.length + 1;
    var slides = [shot(p, 900)].concat(photos.map(function (u, i) {
      return (i ? '' : '<span class="fw__sheet-tag">Inside</span>') +
        '<img src="' + esc(sized(u, 800)) + '" alt="' + esc(label(p)) + (i ? '' : ', open to show the inside') + '" width="800" height="1000"' +
        (i ? ' loading="lazy"' : '') + ' decoding="async">';
    }));
    var full = st.picks.length >= SET;
    sheet.innerHTML =
      '<div class="fw__sheet-hd"><span class="fw__sheet-kind">' + kindName(p) + '</span>' +
      '<button type="button" class="fw__sheet-x" data-x aria-label="Close">×</button></div>' +
      '<div class="fw__sheet-galwrap">' +
        '<div class="fw__sheet-gal" data-g>' + slides.map(function (h, i) { return '<div class="fw__sheet-sl' + (i === 1 ? ' fw__sheet-sl--in' : '') + '">' + h + '</div>'; }).join('') + '</div>' +
        '<span class="fw__sheet-n" data-n aria-live="polite">1 / ' + n + '</span>' +
        (n > 1 ? '<span class="fw__sheet-swipe" data-swipe aria-hidden="true">Swipe for more photos ›</span>' : '') +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--p" data-ap aria-label="Previous photo">‹</button>' +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--n" data-an aria-label="Next photo">›</button>' +
      '</div>' +
      '<div class="fw__sheet-dots" data-d>' + slides.map(function (_, i) { return '<button type="button" data-i="' + i + '"' + (i ? '' : ' aria-current="true"') + ' aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') + '</div>' +
      '<div class="fw__sheet-b">' +
        '<div class="fw__sheet-row"><h3>' + esc(label(p)) + '</h3><span class="pr">' + money(p.price) + '</span></div>' +
        (p.note ? '<p class="note">' + esc(p.note) + '</p>' : '') +
        '<p class="facts">' + (isMini(p) ? '4.5″ × 3.2″ × 1″ · zip top · cards, cash, coins' : '4.3″ × 7.9″ × 1″ · zip-around · wrist strap') + ' · vegan leather</p>' +
        '<button type="button" class="fw__sheet-pick' + (full ? ' is-on' : '') + '" data-pick>' + (full ? 'Swap for my first pick' : 'Add to my ' + SET) + '</button>' +
      '</div>';
    var g = sheet.querySelector('[data-g]'), d = sheet.querySelector('[data-d]'), cnt = sheet.querySelector('[data-n]'), sw = sheet.querySelector('[data-swipe]');
    // One slide = its width + the gap (slides are narrower than the gallery, so the next one peeks in).
    var step = function () { return n > 1 ? Math.max(1, g.children[1].offsetLeft - g.children[0].offsetLeft) : Math.max(1, g.clientWidth); };
    var cur = function () { return Math.round(g.scrollLeft / step()); };
    var go = function (i) { g.scrollTo({left: Math.max(0, Math.min(n - 1, i)) * step(), behavior: 'smooth'}); };
    g.addEventListener('scroll', function () {
      var i = cur();
      Array.prototype.forEach.call(d.children, function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      cnt.textContent = (i + 1) + ' / ' + n;
      if (sw && i > 0) sw.hidden = true;
    }, {passive: true});
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) go(Number(b.getAttribute('data-i'))); });
    sheet.querySelector('[data-ap]').addEventListener('click', function () { go(cur() - 1); });
    sheet.querySelector('[data-an]').addEventListener('click', function () { go(cur() + 1); });
    sheet.querySelector('[data-x]').addEventListener('click', closeSheet);
    sheet.querySelector('[data-pick]').addEventListener('click', function () { closeSheet(); add(p); });
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    document.documentElement.classList.add('fw-sheet-open');
    if (n > 1) g.scrollLeft = step();
  }
  function closeSheet() { if (sheet.close) sheet.close(); else sheet.removeAttribute('open'); }
  sheet.addEventListener('close', function () { document.documentElement.classList.remove('fw-sheet-open'); });
  sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });

  drawGrids();
  render();
})();

/*
 * Judge.me widget on the wallet clearance page (pinned copy of handbag-set-lp/variants/hs-reviews.js): 5-star reviews first (with photos first inside each star level), then 4, 3, 2, 1;
 * one "Load more reviews" button; no sort menu, no filtering by star. Every review stays reachable.
 * Store-wide Judge.me settings stay as they are. Pages come from Judge.me's own public widget endpoint, one star level
 * at a time (sort_by=pictures_first&filter_rating=N), and are set up by Judge.me (jdgm.customizeReviews) so photos,
 * read-more and votes work as on its own pages. If anything fails, Judge.me's widget is left as it was.
 */
(function () {
  'use strict';
  var box = document.querySelector('.fw .fw__jm');
  if (!box) return;
  var PER_PAGE = 5;
  var LEVELS = [5, 4, 3, 2, 1];
  var LABEL = 'Load more reviews';
  // Judge.me's CDN now and then answers without CORS headers; the origin API (the pager's own data-url) is the retry
  var ENDPOINTS = ['https://cdn.judge.me/reviews/reviews_for_widget', 'https://api.judge.me/reviews/reviews_for_widget'];

  var widget, list, btn;
  var at = {level: 0, page: 0, total: null}; // last page loaded of LEVELS[level]
  var busy = false;

  function url(level, page, endpoint) {
    var p = {url: '', shop_domain: '', platform: 'shopify'};
    try { var sp = window.jdgm && jdgm.shopParams && jdgm.shopParams(); if (sp) for (var k in sp) p[k] = sp[k]; } catch (e) {}
    p.product_id = widget.getAttribute('data-id');
    p.page = page; p.per_page = PER_PAGE; p.sort_by = 'pictures_first'; p.filter_rating = LEVELS[level];
    if (!p.shop_domain && window.Shopify) p.shop_domain = p.url = Shopify.shop;
    return endpoint + '?' + Object.keys(p).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]); }).join('&');
  }

  function getJson(level, page, i) {
    return fetch(url(level, page, ENDPOINTS[i])).then(function (r) { if (!r.ok) throw new Error('judge.me ' + r.status); return r.json(); })
      .catch(function (e) {
        if (i + 1 >= ENDPOINTS.length) throw e;
        return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return getJson(level, page, i + 1); });
      });
  }

  function fetchPage(level, page) {
    return getJson(level, page, 0)
      .then(function (j) {
        var t = document.createElement('template');
        t.innerHTML = j.html || '';
        return {total: Number(j.total_count) || 0, revs: Array.prototype.slice.call(t.content.querySelectorAll('.jdgm-rev'))};
      });
  }

  // Next page in order; moves on to the next star level when one runs out. Resolves to [] when everything is shown.
  function next() {
    var lv = at.level, pg = at.page + 1;
    if (at.total != null && at.page * PER_PAGE >= at.total) { lv += 1; pg = 1; }
    if (lv >= LEVELS.length) return Promise.resolve([]);
    return fetchPage(lv, pg).then(function (res) {
      if (pg === 1) at.total = res.total;
      at.level = lv; at.page = pg;
      if (!res.revs.length) { at.total = 0; return next(); }
      return res.revs;
    });
  }

  function more() {
    return at.level < LEVELS.length - 1 || at.total == null || at.page * PER_PAGE < at.total;
  }

  function add(revs, replace) {
    if (replace) list.innerHTML = '';
    revs.forEach(function (r) { list.appendChild(r); });
    // let Judge.me set up the new reviews: read more, votes, dates (every review not yet set up), then the photo viewer
    // (without setupPictures a photo opens in a new tab instead of Judge.me's gallery)
    try {
      if (window.jdgm && jdgm.customizeReviews) jdgm.customizeReviews();
      if (window.jdgm && jdgm.setupPictures && jdgm.$) jdgm.setupPictures(jdgm.$(revs));
    } catch (e) { if (window.console) console.warn('[wallet-clearance] reviews setup', e); }
    btn.hidden = !more();
  }

  function load(replace) {
    if (busy) return Promise.resolve();
    busy = true;
    btn.disabled = true; btn.textContent = 'Loading…';
    return next().then(function (revs) { add(revs, replace); })
      .catch(function (e) { if (window.console) console.warn('[wallet-clearance] reviews', e); if (replace) throw e; })
      .then(function () { busy = false; btn.disabled = false; btn.textContent = LABEL; });
  }

  function start() {
    widget = box.querySelector('.jdgm-widget');
    list = widget && widget.querySelector('.jdgm-rev-widg__reviews');
    // wait until Judge.me has set up its widget, so our first page replaces its list and not the other way round
    if (!list || !box.querySelector('.jdgm--done-setup')) return false;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hs-rv__more';
    btn.textContent = LABEL;
    btn.addEventListener('click', function () { load(false); });
    list.parentNode.insertBefore(btn, list.nextSibling);
    load(true).then(function () { box.classList.add('hs-rv-on'); }, function () { btn.remove(); });
    return true;
  }
  if (!start()) {
    var tries = 0;
    var t = setInterval(function () { if (start() || ++tries > 60) clearInterval(t); }, 250);
  }
})();
